/* tslint:disable */
import {NgModule} from '@angular/core';
import {ExtraOptions, PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {CommonModule} from '@angular/common';
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";

const routerOptions: ExtraOptions = {
    useHash: false,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    // scrollOffset: [0, 64],
    //preloadingStrategy:PreloadAllModules, //to preload lazy loaded code and enhance the performance
};
const routes: Routes = [
    {path: 'atlas', loadChildren: () => import('./atlas/atlas.module').then(m => m.AtlasModule)},
    {path: 'home', loadChildren: () => import('./home-page/home-page.module').then(m => m.HomePageModule)},
    {path: 'downloads', loadChildren: () => import('./downloads/downloads.module').then(m => m.DownloadsModule)},
    {path: 'authentication', loadChildren: () => import('./user-authentication/user-authentication.module').then(m => m.UserAuthenticationModule)},
    {path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
    {path: 'guide', loadChildren: () => import('./atlas-guide/atlas-guide.module').then(m => m.AtlasGuideModule)},
    {path: '', redirectTo: 'home', pathMatch: 'full'},
    {path: 'zebrafishatlas/main_page', redirectTo: 'home', pathMatch: 'full'},
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [CommonModule, RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})

export class AppRoutingModule {
}
